// @flow
import React from "react";
import { faHeart } from "@fortawesome/pro-solid-svg-icons";

import FontAwesomeIcon from "../FontAwesomeIcon";
import getSizeClass from "../../../helpers/getFontAwesomeSizeClassname";

type Props = {
  size?: 14 | 16 | 24 | 32 | 40 | 48,
  className?: string
};

const Heart = ({ size, className = "" }: Props) => {
  const sizeClass = getSizeClass(size);

  return (
    <div className={`${sizeClass} ${className}`}>
      <FontAwesomeIcon icon={faHeart} className={sizeClass} />
    </div>
  );
};

export default Heart;
